import { IconWrapper } from '../runtime';
export default IconWrapper('address-book', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 3.99976V2.74976C1.75 2.19747 2.19772 1.74976 2.75 1.74976H13.25C13.8023 1.74976 14.25 2.19747 14.25 2.74976V13.2498C14.25 13.802 13.8023 14.2498 13.25 14.2498H2.75C2.19772 14.2498 1.75 13.802 1.75 13.2498V11.9998",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M11.4034 11.4997C10.9905 10.2371 9.60492 9.25146 8 9.25146C6.39508 9.25146 5.03608 10.2371 4.62317 11.4997M1.75 6.49968H3M1.75 9.49968H3M10 6.25146C10 7.35603 9.10457 8.25146 8 8.25146C6.89543 8.25146 6 7.35603 6 6.25146C6 5.1469 6.89543 4.25146 8 4.25146C9.10457 4.25146 10 5.1469 10 6.25146Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});